module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "legend-wrapper"
  }, [_c('ul', _vm._l((_vm.legendArr), function(legend, index) {
    return _c('li', {
      style: (_vm.styleArr[index]),
      on: {
        "mouseout": function($event) {
          _vm.donwplay(index)
        },
        "mouseover": function($event) {
          _vm.highlight(index)
        },
        "click": function($event) {
          _vm.legendToggle(legend)
        }
      }
    }, [_vm._v("\n        " + _vm._s(legend.name) + "\n      ")])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cb5db06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 580
// module chunks = 2